import React from 'react';
import styled from '@emotion/styled';

type Props = {
  label: string,
  searchText: string,
};
/* eslint-disable react/no-array-index-key */
export const AddressLookupHighlitedLabel = ({ label, searchText }: Props) => {
  if (!searchText) return null;
  const parts = label.split(new RegExp(`(${searchText})`, 'gi'));
  return (
    <div>
      {parts.map(
        (w, i) =>
          w && (
            <Label key={`${w}-${i}`} strong={w.toLowerCase() === searchText.toLowerCase()}>
              {w}
            </Label>
          )
      )}
    </div>
  );
};

const Label = styled('span')`
  font-weight: ${({ theme, strong }) => strong && theme.fontWeight.bold};
`;
